export default __webpack_public_path__ + "static/media/money-back@3x.da10d923.png";